var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutBase", [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "loading" },
          [_c("Spinner", { attrs: { height: 40, width: 40 } })],
          1
        )
      : _vm.error
      ? _c("div", { staticClass: "error" }, [
          _c("p", [_vm._v("Error loading sector tree.")]),
        ])
      : _vm.tree.length
      ? _c(
          "ul",
          _vm._l(_vm.tree, function (sector) {
            return _c("sector-node", {
              key: sector.id,
              attrs: { sector: sector },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }